import FlagIcon from "@mui/icons-material/Flag";
import { IconButton } from "@mui/material";
import { useState } from "react";
import { CrudSort } from "@refinedev/core";
import { FiltersButton } from "./DetailedSearch/FiltersButton";
import { FlagDialog } from "../../../components/flag/FlagDialog";
import { useTranslation } from "../../../hooks/useTranslation";
import { BaseListFilterRow } from "../../../components/BaseListFilterRow";

type Props = {
  sorters: CrudSort[];
};

export const OrderListFilterRow = ({ sorters }: Props) => {
  const { translate } = useTranslation();
  const [flagDialog, setFlagDialog] = useState(false);

  return (
    <>
      <BaseListFilterRow
        placeholder={translate("common.search")}
        sorters={sorters}
        exportUrl="order/export"
        rightActions={
          <IconButton
            size="small"
            color="primary"
            onClick={() => setFlagDialog(true)}
          >
            <FlagIcon />
          </IconButton>
        }
        showFiltersButton={<FiltersButton />}
      />

      <FlagDialog open={flagDialog} onClose={() => setFlagDialog(false)} />
    </>
  );
};
